module.exports = __webpack_public_path__ + "img/XLS.aa766686.svg";